import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalFilterState {
  value: string;
}

const initialState: GlobalFilterState = {
  value: '',
};

const globalFilterSlice = createSlice({
  name: 'globalFilter',
  initialState,
  reducers: {
    setGlobalFilter: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
    clearGlobalFilter: (state) => {
      state.value = '';
    },
  },
});

export const { setGlobalFilter, clearGlobalFilter } = globalFilterSlice.actions;
export default globalFilterSlice.reducer;
